// extracted by mini-css-extract-plugin
export default {"news__list":"NewsList_news__list__L3uoN"};